<template>
  <div class="main-box" v-loader.opacity="loading">
    <div class="">
      <h1>FaÃ§a um upgrade do seu plano</h1>
      <p>Veja abaixo os planos dÃ­sponiveis para atualizar</p>
    </div>

    <div class="btn-group" role="group">
      <input class="btn-check" type="radio" name="periodicity" id="monthly" autocomplete="off" data-test="radioMonthly" value="1">
      <label class="btn btn-outline-secondary" for="monthly">
        mensal
      </label>
      <input class="btn-check" type="radio" name="periodicity" id="yearlyyearly" autocomplete="off" data-test="radioYearly" value="2">
      <label class="btn btn-outline-secondary" for="yearly">
        anual (20% off)
      </label>
    </div>

    <div class="plans">
      <div class="plan-card">
        <div class="">
          <p class="label label-secondary" v-show="!subscriptionName">atual</p>
          <h2>Gratuito</h2>
          <h1>5.000</h1>
          <h3>capturas</h3>
          <button class="btn btn-outline-secondary disabled" type="button" name="button" v-show="!subscriptionName">
            plano atual
          </button>
        </div>

        <div class="text-center" v-html="$t('plans.freePlanInfo')"></div>
      </div>

      <div class="plan-card" :class="{'active': !subscriptionName && index == 0}" v-for="(item, index) in products">
        <div class="">
          <p class="label label-secondary" v-if="subscriptionName == item.name">atual</p>
          <p class="label label-success" v-else-if="!subscriptionName && index == 0">recomendado</p>
          <h2>{{ item.name }}</h2>
          <h1>{{ item.description == 'clinicPlanInfo' ? '30.000' : '100.000' }}</h1>
          <h3>capturas</h3>

          <button class="btn btn-outline-secondary disabled" type="button" name="button" v-if="subscriptionName == item.name">
            plano atual
          </button>
          <button class="btn btn-success" type="button" name="button" @click="openPlansCheckoutOffcanvas(item)" v-else>
            assinar
          </button>

          <h2>R$ {{ formatPriceByMonth(item.price) }}</h2>
          <p class="paragraph">por mÃªs</p>
        </div>

        <div class="text-center" v-html="$t(`plans.${item.description}`)"></div>
      </div>

      <div class="plan-card">
        <div class="">
          <h2>Enterprise</h2>
          <h1>Ilimitado</h1>
          <h3>capturas</h3>
          <button class="btn btn-success" type="button" name="button">
            consultar
          </button>

          <h2>Consultar preÃ§o</h2>
        </div>

        <div class="text-center" v-html="$t('plans.enterprisePlanInfo')"></div>
      </div>
    </div>

    <teleport to="body">
      <PlansCheckoutOffcanvas :offcanvas_id="'PlansCheckoutOffcanvas'" ref="plansCheckoutOffcanvas"/>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
.main-box {
  display: flex;
  flex-direction: column;
  flex: 1;
  // height: calc(100vh - 63px);
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-top: 1px solid var(--Shades-30, #D8D8D8);

  > div {
    &:first-child {
      h1 {
        color: var(--Brand-Primary, #1B294A);
        text-align: center;
        font-size: 38px;
        font-weight: 300;
        line-height: normal;
      }

      p {
        color: var(--Brand-Primary, #1B294A);
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 140%; /* 19.6px */
      }
    }

  }

  .btn-group {
    .btn-outline-secondary {
      @include border_radius(10px 0 0 10px);
      color: var(--Brand-Primary, #1B294A);
      text-align: center;
      font-family: Ubuntu;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 19.6px */
      letter-spacing: 2.8px;
      text-transform: uppercase;
      margin: 0;
      padding: 20px;
      border: 1px solid var(--Shades-30, #D8D8D8);
      background: var(--Shades-10, #FAFAFA);

      &:last-child {
        @include border_radius(0 10px 10px 0);
      }
    }

    .btn-check:checked + .btn.btn-outline-secondary {
      color: var(--Brand-Secondary, #3CB391);
      border: 1px solid var(--Brand-Secondary, #3CB391);
      background: #E3FDF4;
    }
  }

  .plans {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
    align-items: center;

    .plan-card {
      display: flex;
      width: 298px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      border: 1px solid var(--Shades-30, #D8D8D8);
      background: var(--Shades-W, #FFF);

      &.active {
        border: 2px solid var(--Brand-Secondary, #3CB391);
      }

      h2 {
        color: var(--Brand-Primary, #1B294A);
        text-align: center;
        font-family: Ubuntu;
        font-size: 26px;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
        margin: 0;

        &:last-child:not(:first-child) {
          font-weight: 500;
        }
      }

      h1 {
        color: var(--Brand-Primary, #1B294A);
        text-align: center;
        font-family: Ubuntu;
        font-size: 38px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 0;
      }

      h3 {
        color: var(--Brand-Primary, #1B294A);
        text-align: center;
        font-family: Ubuntu;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: uppercase;
        margin: 0;
      }

      .paragraph {
        color: var(--Brand-Primary, #1B294A);
        text-align: center;
        font-family: Ubuntu;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0;
      }

      .label {
        width: fit-content;
        margin: 0 auto 1rem;
      }

      .btn {
        text-align: center;
        font-family: Ubuntu;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 3.6px;
        text-transform: uppercase;
        width: 100%;
        padding: 15px;
        margin: 1rem 0 2rem;

        &.btn-outline-secondary.disabled {
          color: var(--Shades-40, #B7B7B7);
          border: 1px solid var(--Shades-40, #B7B7B7);
          background: var(--Shades-10, #FAFAFA);
          cursor: not-allowed;
          pointer-events: none;
        }
      }

      > div {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;
        padding: 20px;

        &:last-child {
          gap: 15px;
          border-top: 1px solid var(--Shades-30, #D8D8D8);
        }
      }
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import PlansCheckoutOffcanvas from './PlansCheckoutOffcanvas.vue'

export default {
  name: 'new-plans',
  components: {
    PlansCheckoutOffcanvas
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    products: {},
    session: null,
    subscriptionName: '',
  }),
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
    console.log('sessao new plans', this.session);
    this.getClinicSubscription(this.session.currentClinic.email)
    this.fetchData()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async fetchData() {
      this.alert.message = null;

      this.loading = true
      NProgress.start()
      try {
        const response = await this.$stripeService.list();

        console.log('response stripe', response);

        this.products = response.result.data.reverse()

        this.products.forEach(async (o) => {
          if (o.default_price)
            o.price = await this.fetchDataPrice(o.default_price)

          if (o.default_price && o.price)
            o.totalValue = this.formatPrice(o.price.unit_amount, 1)

          o.quantity = 1

          await this.getSubscribers(o.price.product)
        })

      } catch(err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    async getSubscribers(id) {
      console.log('id', id);
      this.alert.message = null;

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$stripeService.getSubscribers({productID: id});
        console.log('response subscribers', response);
        // return response.result
      } catch(err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    async getClinicSubscription(email) {
      console.log('email', email);
      this.alert.message = null;

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$stripeService.getClinicSubscription({email: email});
        console.log('response clinic subscriber', response);
        // if (response.length)
        this.subscriptionName = this.getProductName(response.subscriptions)
        console.log(this.subscriptionName);
        // return response.result
      } catch(err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    getProductName(subscriptions) {
      if (!subscriptions || subscriptions.length === 0) return null;

      const companyProduct = subscriptions.find(sub => sub.product_name === "Company");
      return companyProduct ? "Company" : (subscriptions[0]?.product_name || null);
    },
    async fetchDataPrice(id) {
      this.alert.message = null;

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$stripeService.getPrice({id: id});
        console.log('response data price', response);
        // console.log('response prices', (response.result.unit_amount / 100).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","));
        return response.result
      } catch(err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    toCheckout(item) {
      this.$router.push({name: 'checkout', query: {priceID: item.default_price, quantity: item.quantity}})
    },
    formatPrice(value, multiply) {
      let valueWithQuantity = value * multiply
      return (valueWithQuantity / 100).toFixed(2)
    },
    formatPriceByMonth(item) {
      // if (!item.unit_amount)
      //   return 0

      let monthValue = (item.unit_amount / 100).toFixed(2)

      if (item.recurring.interval == 'year')
        return (monthValue / 12).toFixed(2)
      else
        return (monthValue / item.recurring.interval_count).toFixed(2)
    },
    change(item, event) {
      item.quantity = event.target.value
      item.totalValue = this.formatPrice(item.price.unit_amount, event.target.value)
    },
    async openPlansCheckoutOffcanvas(item) {
      const ok = await this.$refs.plansCheckoutOffcanvas.show({
        priceID: item.default_price,
        quantity: item.quantity,
        clinicUUID: this.session.currentClinic.uuid,
        clinicEmail: this.session.currentClinic.email,
        clinicName: this.session.currentClinic.name
      })
      if (ok) { }
    }
  }
}
</script>
